import React from 'react';

import Dialog from '../../Dialog';
import DialogExtraImage from '../../Dialog/extras/image';
import DialogExtraCaption from '../../Dialog/extras/caption';

import trashImage from '../../../../assets/illustrations/trash-files.svg';

interface IProps {
  onCancel: () => void;
  onConfirm: () => void;
  show: boolean;
}

const ModalUploadSingle = ({ onCancel, onConfirm, show }: IProps) => (
  <Dialog
    maxWidth="360px"
    persistence
    show={show}
    textButtonA="Sí, eliminar"
    textButtonB="Cancelar"
    zIndex={1000}
    handlerButtonA={() => onConfirm()}
    handlerButtonB={() => onCancel()}
    handlerClose={() => onCancel()}
  >
    <DialogExtraImage alt="trashImage" src={trashImage} />
    <DialogExtraCaption
      subtitle="Recuerda que una vez eliminado no lo podrás recuperar."
      title="¿Deseas eliminar este archivo?"
    />
  </Dialog>
);

export default ModalUploadSingle;
